import { render, staticRenderFns } from "./Version5.vue?vue&type=template&id=e8019ce4&"
import script from "./Version5.vue?vue&type=script&lang=js&"
export * from "./Version5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports